import { CAM_NAV, type CamNavItem } from '@/cam-admin/CamShell';

// In-prototype section addresses. The descoping stage intercepts these on the
// nav rail and switches the in-page section rather than changing routes, so the
// whole prototype stays on the single /descoping-cam route.
export const CIRCLES_PATH = '/descoping-cam';
export const CASELOADS_PATH = '/descoping-cam/caseloads';
// Opening a care circle from within the prototype — its control panel, shown
// with the descoping rail so you stay inside the descoping project.
export const CIRCLE_PATH = '/descoping-cam/circle';

// The descoping CAM rail: Your caseloads first, then the full All care circles
// index, then the standard rail's remaining items.
export const DESCOPING_NAV: CamNavItem[] = [
  { label: 'Your caseloads', icon: 'clipboard-list', path: CASELOADS_PATH },
  { label: 'All care circles', icon: 'house', path: CIRCLES_PATH },
  ...CAM_NAV.filter((i) => i.label !== 'Care circles'),
];
